// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsn-form {
  display: flex;
  flex-direction: column;
  row-gap: 0.9rem;
  max-width: calc(var(--main-font-size-primary) * 37);
  margin: auto;
  padding: 1rem;
}
.lsn-form[hidden] {
  display: none;
}
.lsn-form-bordered {
  border: var(--main-border-width) solid var(--main-border-color);
  border-radius: var(--main-border-radius);
  background-color: var(--main-bg-color-lighter);
}
.lsn-form-narrow {
  max-width: calc(var(--main-font-size-primary) * 27);
}
.lsn-form-medium {
  max-width: calc(var(--main-font-size-primary) * 30);
}
.lsn-form-no-spacings {
  padding: 0;
  margin: 0;
}
.lsn-form > .form-icon {
  text-align: center;
  font-size: 115px;
  line-height: normal;
  color: var(--main-gray);
  margin: 0;
  padding-block-end: 0.9rem;
}
.lsn-form > .form-icon i {
  display: block;
  line-height: normal;
}
.lsn-form > .form-icon i:before {
  line-height: normal;
}
.lsn-form > .form-content {
  display: flex;
  flex-direction: column;
}
.lsn-form > .form-content p {
  padding-bottom: 0.68rem;
}
.lsn-form > .form-content .form-group:last-child {
  margin-bottom: 0.9rem;
}
.lsn-form > .form-buttons {
  margin: 0;
  width: 100%;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  align-items: center;
  justify-content: space-evenly;
}
.lsn-form > .form-buttons-vertical {
  flex-direction: column;
  align-items: stretch;
}
.lsn-form > .form-extra-footer {
  margin-top: 0;
}
@media (min-width: 990px) {
  .lsn-form {
    padding: 1.6rem;
  }
  .lsn-form-no-spacings {
    padding: 0;
    margin: 0;
  }
  .lsn-form .form-buttons {
    flex-direction: row;
    column-gap: 1rem;
  }
  .lsn-form .form-buttons > button {
    flex-grow: 1;
  }
  .lsn-form .form-buttons-vertical {
    align-items: stretch;
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/controls/Form/Form.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,mDAAA;EACA,YAAA;EACA,aAAA;AACF;AACE;EACE,aAAA;AACJ;AAEE;EACE,+DAAA;EACA,wCAAA;EACA,8CAAA;AAAJ;AAGE;EACE,mDAAA;AADJ;AAIE;EACE,mDAAA;AAFJ;AAKE;EACE,UAAA;EACA,SAAA;AAHJ;AAzBA;EAgCI,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,yBAAA;AAJJ;AAjCA;EAwCM,cAAA;EACA,mBAAA;AAJN;AAMM;EACE,mBAAA;AAJR;AAxCA;EAkDI,aAAA;EACA,sBAAA;AAPJ;AA5CA;EAsDM,uBAAA;AAPN;AA/CA;EA0DM,qBAAA;AARN;AAlDA;EA+DI,SAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AAVJ;AAYI;EACE,sBAAA;EACA,oBAAA;AAVN;AAhEA;EA+EI,aAAA;AAZJ;AAgBA;EACE;IACE,eAAA;EAdF;EAgBE;IACE,UAAA;IACA,SAAA;EAdJ;EASA;IASI,mBAAA;IACA,gBAAA;EAfJ;EAKA;IAaM,YAAA;EAfN;EAkBI;IACE,oBAAA;IACA,sBAAA;EAhBN;AACF","sourcesContent":[".lsn-form {\n  display: flex;\n  flex-direction: column;\n  row-gap: .9rem;\n  max-width: calc(var(--main-font-size-primary) * 37);\n  margin: auto;\n  padding: 1rem;\n\n  &[hidden] {\n    display: none;\n  }\n\n  &-bordered {\n    border: var(--main-border-width) solid var(--main-border-color);\n    border-radius: var(--main-border-radius);\n    background-color: var(--main-bg-color-lighter);\n  }\n\n  &-narrow {\n    max-width: calc(var(--main-font-size-primary) * 27);\n  }\n\n  &-medium {\n    max-width: calc(var(--main-font-size-primary) * 30);\n  }\n\n  &-no-spacings {\n    padding: 0;\n    margin: 0;\n  }\n\n  >.form-icon {\n    text-align: center;\n    font-size: 115px;\n    line-height: normal;\n    color: var(--main-gray);\n    margin: 0;\n    padding-block-end: .9rem;\n\n    i {\n      display: block;\n      line-height: normal;\n\n      &:before {\n        line-height: normal;\n      }\n    }\n  }\n\n  >.form-content {\n    display: flex;\n    flex-direction: column;\n\n    p {\n      padding-bottom: .68rem;\n    }\n\n    .form-group:last-child {\n      margin-bottom: .9rem;\n    }\n  }\n\n  >.form-buttons {\n    margin: 0;\n    width: 100%;\n    margin-top: 1rem;\n    display: flex;\n    flex-direction: column;\n    row-gap: 10px;\n    align-items: center;\n    justify-content: space-evenly;\n\n    &-vertical {\n      flex-direction: column;\n      align-items: stretch;\n    }\n  }\n\n  >.form-extra-footer {\n    margin-top: 0;\n  }\n}\n\n@media (min-width: 990px) {\n  .lsn-form {\n    padding: 1.6rem;\n\n    &-no-spacings {\n      padding: 0;\n      margin: 0;\n    }\n\n    .form-buttons {\n      flex-direction: row;\n      column-gap: 1rem;\n\n      >button {\n        flex-grow: 1;\n      }\n\n      &-vertical {\n        align-items: stretch;\n        flex-direction: column;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
